import AxiosClient from "../../../services/axios.services";

class AudiencesActionsServices {
  getDataBoss = (id) =>
    AxiosClient.get(`/api/app/Funcional_Empleado_Jefe/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  createAudience = (data) =>
    AxiosClient.post("/api/app/sanciones_crear_audiencia/", data, {
      headers: { "Content-Type": "application/json" },
    });
  getAudiences = () =>
    AxiosClient.get(`/api/app/sanciones_audiencias/`, {
      headers: { "Content-Type": "application/json" },
    });
  deleteAudience = (id) =>
    AxiosClient.delete(`/api/app/sanciones_audiencias_eliminar/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  updateAudience = (data, id) =>
    AxiosClient.patch(`/api/app/sanciones_audiencias_actualizar/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  emailSend = (data, id) =>
    AxiosClient.post(`/api/app/sanciones_audiencias_correo/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new AudiencesActionsServices();
